import services from "@/services/index.js";
import parameters from "@/constants/parameters.js";

export default {

    getRecentlySeen: async () => {
        return await services.getAsync({
            url: `/preferences/recents`,
            hasToken: true
        });
    },

    getSearchListMajorVersion: async () => {
        return await services.getAsync({
            url: `/preferences/searches/${process.env.VUE_APP_DB_VERSION}`,
            hasToken: true
        });
    },

    postFakeDoorClick: async ({ resource, confirm = null }) => {
        return await services.postAsync({
            url: `/preferences/fake-doors`,
            body: { resource, confirm },
            timeout: 10000,
            hasToken: true
        });
    },

    getVersions: async (user) => {
        const payload = await services.getAsync({
            url: '/preferences/versions',
            timeout: 20000,
            hasToken: !!user && !!user.uid,
            refreshToken: true
        });
        if (payload.forbiddenAppVersion) {
            return { status: parameters.FORBIDDEN_APP_VERSION, payload };
        } else if (payload.hasNewAppVersion) {
            return { status: parameters.OUTDATED_APP_VERSION, payload };
        }
        return { status: parameters.OK_APP_VERSION, payload };
    },


    getCardsProgress: async () => {
        return await services.getAsync({
            url: `/preferences/cards/progress`,
            hasToken: true
        });
    },

    getCardsByContentId: async (content_id) => {
        return await services.getAsync({
            url: `/preferences/cards/contents/${encodeURIComponent(content_id)}`,
            hasToken: true
        });
    },

    getCardsByProps: async (content_type, card_class) => {
        const query = `content_type=${encodeURIComponent(content_type)}&card_class=${encodeURIComponent(card_class)}`;
        return await services.getAsync({
            url: `/preferences/cards?${query}`,
            hasToken: true
        });
    },

    postCardAnswers: async (answers) => {
        return await services.postAsync({
            url: '/preferences/cards',
            body: { answers },
            timeout: 10000,
            hasToken: true
        });
    },

    getFavorites: async () => {
        return await services.getAsync({
            url: '/preferences/favorites',
            hasToken: true
        });
    },

    postFavorites: async (favorite) => {
        return await services.postAsync({
            url: '/preferences/favorites',
            body: favorite,
            hasToken: true
        });
    },

    postAdsClick: async (confirm, elapsedSeconds, ads_uid) => {
        await services.postAsync({
            url: '/preferences/ads',
            body: { confirm, elapsedSeconds, ads_uid },
            timeout: 10000,
            hasToken: true
        });
    },

    getAds: async (location, breakpoint, index) => {
        return await services.getAsync({
            url: '/preferences/ads?location='
                + encodeURIComponent(location) + '&breakpoint='
                + encodeURIComponent(breakpoint)
                + '&index=' + encodeURIComponent(index),
            timeout: 10000,
            hasToken: true
        });
    }
}